import { fetcher } from "../../utils/fetcher.js";

export const getAllTasks = (showCompleted, projectId, boardId) => {
  const params = [];
  if (showCompleted !== undefined)
    params.push(`showCompleted=${showCompleted}`);
  if (projectId) params.push(`projectId=${projectId}`);
  if (boardId) params.push(`boardId=${boardId}`);
  const query = params.length ? `?${params.join("&")}` : "";
  return fetcher.get(`/api/tasks${query}`);
};
